<template>
  <div>
    <v-card outlined>
      <v-card-title>
        {{ $capitalize($tc("model.teams_management_title")) }}
        <v-spacer></v-spacer>
        <ScopeProvider scope="leads.update_team">
          <v-btn @click="handleTogleReadOnly" icon>
            <v-icon> mdi-pencil </v-icon>
          </v-btn>
        </ScopeProvider>
      </v-card-title>

      <v-card-text>
        <v-row dense>
          <v-col>
            <v-select
              :items="teams"
              item-text="name"
              :value="team"
              @change="handleChangeTeam"
              return-object
              :label="
                $capitalize($tc('model.teams_team_label'))
              "
              hide-details
              :disabled="readonly"
              :loading="loading_teams"
            ></v-select>
          </v-col>
        </v-row>
        <v-row dense>
          <v-col>
            <v-select
              :label="
                $capitalize($tc('model.teams_manager_label'))
              "
              item-text="id"
              :items="managers"
              :value="manager"
              @change="handleChangeManager"
              return-object
              hide-details
              :disabled="readonly"
              :loading="loading_managers"
              clearable
            >
              <template v-slot:selection="{ item }">
                <div>
                  {{ item.user.name }}
                </div>
              </template>
              <template v-slot:item="{ item }">
                <div>
                  {{ item.user.name }}
                </div>
              </template>
            </v-select>
          </v-col>
        </v-row>
        <v-row dense>
          <v-col>
            <v-select
              :label="
                $capitalize($tc('model.teams_unity_label'))
              "
              item-text="id"
              :items="unities"
              :value="unity"
              @change="handleChangeUnity"
              return-object
              hide-details
              :disabled="readonly"
              :loading="loading_unities"
              clearable
            >
              <template v-slot:selection="{ item }">
                <div>
                  {{ item.user.name }}
                </div>
              </template>
              <template v-slot:item="{ item }">
                <div>
                  {{ item.user.name }}
                </div>
              </template>
            </v-select>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import { index as indexTeams } from "@/services/teams";
import { index as indexManagers } from "@/services/service_managers";
import { indexUnities } from "@/services/lead";
import {
  change_team as changeLeadTeam,
  change_manager as changeLeadManager,
  change_unity as changeLeadUnity,
} from "@/services/lead";
import ScopeProvider from "@/components/ScopeProvider";

export default {
  name: "lead-management-list",
  components: { ScopeProvider },
  props: {
    team: {
      type: Object,
      default: null,
    },
    manager: {
      type: Object,
      default: null,
    },
    unity: {
      type: Object,
      default: null,
    },
    lead_id: {
      type: Number,
    },
  },
  data: () => ({
    teams: [],
    loading_teams: false,
    loading_managers: false,
    managers: [],
    loading_unities: false,
    unities: [],
    readonly: true,
  }),
  methods: {
    async getTeams() {
      this.loading_teams = true;
      try {
        const response = await indexTeams({ list: true });
        this.teams = response;
      } catch (error) {
        this.$store.commit("error", error);
      } finally {
        this.loading_teams = false;
      }
    },
    async getManagers() {
      this.managers = [];
      this.loading_managers = true;
      try {
        const response = await indexManagers({
          list: true,
          team_id: this.team ? this.team.id : null,
        });
        this.managers = response.map((manager) => {
          return {
            id: manager.id,
            lead_type_id: manager.lead_type_id,
            team_id: manager.team_id,
            created_at: manager.created_at,
            updated_at: manager.updated_at,
            user: {
              id: manager.user_id,
              name: manager.user_name,
              avatar_url: manager.user_avatar,
            },
            user_id: manager.user_id,
          };
        });
      } catch (error) {
        this.$store.commit("error", error);
      } finally {
        this.loading_managers = false;
      }
    },
    async getUnities() {
      this.loading_unities = true;
      try {
        const response = await indexUnities(this.$route.params["lead_number"], this.team?.id);
        this.unities = response;
      } catch (error) {
        this.$store.commit("error", error);
      } finally {
        this.loading_unities = false;
      }
    },
    handleTogleReadOnly() {
      this.readonly = !this.readonly;
    },
    async handleChangeTeam(team) {
      this.loading_teams = true;
      try {
        await changeLeadTeam(this.lead_id, team.id);
        this.$emit("team_changed", team);
      } catch (error) {
        this.$store.commit("error", error);
      } finally {
        this.loading_teams = false;
      }
    },
    async handleChangeManager(manager) {
      this.loading_managers = true;
      try {
        await changeLeadManager(this.lead_id, { service_manager: manager });
        this.$emit("manager_changed", manager);
      } catch (error) {
        this.$store.commit("error", error);
      } finally {
        this.loading_managers = false;
      }
    },
    async handleChangeUnity(unity) {
      this.loading_unities = true;
      try {
        await changeLeadUnity(this.lead_id, { unity });
        this.$emit("unity_changed", unity);
      } catch (error) {
        this.$store.commit("error", error);
      } finally {
        this.loading_unities = false;
      }
    },
  },
  watch: {
    readonly: function (value) {
      if (value == false) {
        this.getTeams();
        this.getManagers();
        this.getUnities();
      }
    },
    team: function (value, old_value) {
      if (old_value === null && value.id && this.teams.length == 0) {
        this.teams = [value];
      } else {
        this.getManagers();
        this.getUnities();
      }
    },
    manager: function (value, old_value) {
      if (old_value === null && value.id && this.managers.length == 0) {
        this.managers = [value];
      }
    },
    unity: function (value, old_value) {
      if (old_value === null && value.id && this.unities.length == 0) {
        this.unities = [value];
      }
    },
  },
  created() {
    if (this.readonly == false) {
      this.getTeams();
    }
  },
};
</script>